var TmamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, map } from "rxjs";
import { ModuleConfig } from "../../models/module-config.model";
import { ODataAction } from "../odata-query/odata-action.model";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { Router } from "@angular/router";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { SharedConstants } from "../../constants/shared.constants";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ApiTrainingConstants } from "../../constants/api-constants/api-training.constants";
import { ViewApplicationDetailsTmamsComponent } from "../../../view-application/modules/tm/view-application-details-tmams/view-application-details-tmams.component";
import { ViewApplicationLocationTmamsComponent } from "../../../view-application/modules/tm/view-application-location-tmams/view-application-location-tmams.component";
import { CreateApplicationDetailsTmamsComponent } from "../../../create-application/modules/tm/create-application-details-tmams/create-application-details-tmams.component";
import { CreateApplicationLocationTmamsComponent } from "../../../create-application/modules/tm/create-application-location-tmams/create-application-location-tmams.component";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { AppControllerService } from "../../../app-controller.service";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    // [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    // [ApplicationHeadingEnum.ErfNumber, "erfNumbers"],
    // [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.CreatedDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export const DMExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_TM;
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export var CreateApplicationTrainingMenuHeadings;
(function (CreateApplicationTrainingMenuHeadings) {
    CreateApplicationTrainingMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationTrainingMenuHeadings["Location"] = "Properties";
    CreateApplicationTrainingMenuHeadings["Details"] = "Application";
    CreateApplicationTrainingMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationTrainingMenuHeadings["Agent"] = "Agent";
    CreateApplicationTrainingMenuHeadings["Notes"] = "Notes";
    CreateApplicationTrainingMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationTrainingMenuHeadings || (CreateApplicationTrainingMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Properties help";
    HeaderConfigurableTextTypes["Application"] = "Training application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Application summary";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationTrainingMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationTrainingMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationTrainingMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationTrainingMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationTrainingMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationTrainingMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["Details"] = "Application";
    ViewApplicationMenuHeadings["Location"] = "Properties";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let TmamsStrategyService = class TmamsStrategyService extends AflaModuleStrategyService {
    static { TmamsStrategyService_1 = this; }
    saShortDatePipe;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    applicationCreateService;
    router;
    name = ModuleConfig.TrainingModule;
    applicationEndpoint;
    defaultSearchColumns;
    viewApplicationComponentLookup;
    createApplicationComponentLookup;
    createApplicationMenuHeadings;
    viewApplicationMenuHeadings;
    form;
    applicationServiceUrl = ApiTrainingConstants.URL;
    moduleUsers;
    expandListForApplicationPartial = DMExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    applicationSummaryColumnsMap;
    savedApplication;
    previousApplication = null;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, applicationCreateService, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.applicationCreateService = applicationCreateService;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiTrainingConstants.URL}/${ApiTrainingConstants.FUNCTION_GET_MY_AFLA_PORTAL_TRAINING_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationTrainingMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, DMExpandListForApplicationSearch);
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    buildListFilter(list, column) {
        const params = TmamsStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_TM_APPLICATION_BY_USER;
        }
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsTmamsComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationTmamsComponent],
            [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationTrainingMenuHeadings.Details, CreateApplicationDetailsTmamsComponent],
            [CreateApplicationTrainingMenuHeadings.Location, CreateApplicationLocationTmamsComponent],
            [CreateApplicationTrainingMenuHeadings.Notes, CreateApplicationNotesComponent],
        ]);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationTrainingMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === CreateApplicationTrainingMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getApplicationsQuery(params, useCompleteListForSearch) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiTrainingConstants.URL}/${ApiTrainingConstants.FUNCTION_GET_ALL_AFLA_PORTAL_TRAINING_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = TmamsStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, TmamsStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription = this.postApplicationService(application).subscribe((savedApplication) => {
            this.appControllerService.showMessage(TmamsStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
            this.resetForm();
            this.router.navigate([AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]);
        }, (error) => {
            this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Add);
        });
    }
    postApplicationService(params) {
        return this.http.post(ApiTrainingConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: TmamsStrategyService_1.getRecipientName(TmamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: TmamsStrategyService_1.getRecipientName(TmamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate), // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
        };
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiTrainingConstants.URL}/${applicationId}/${ApiTrainingConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        return this.http.post(`${ApiTrainingConstants.URL}/${applicationId}/${ApiTrainingConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appControllerService.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationTrainingMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildTrainingDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationTrainingMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationTrainingMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationTrainingMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationTrainingMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationTrainingMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                tmApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this as the saved application does not return with the updated family members
                    const params = {
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID} and deleted eq false`,
                        $expand: "applicant,applicantAgent,properties($expand=owners),attachments,notes"
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            this.savedApplication = response.value[0];
                        }, error: (error) => {
                            this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appControllerService.showMessage(TmamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.tmApplication.eLodgementStep;
                                // NB: DO NOT REMOVE THIS LINE UNLESS YOU HAVE A GOOD REASON! OTHERWISE, IT'S GOING TO CAUSE DUPLICATES!!!!
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appControllerService.showMessage(TmamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                },
            });
        }
        else {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        return;
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationTrainingMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationTrainingMenuHeadings.Location.toLocaleLowerCase():
                formName = "propertiesForm";
                break;
            case CreateApplicationTrainingMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationTrainingMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationTrainingMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationTrainingMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationTrainingMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").get("type").reset();
                this.form.get("detailsForm").get("description").reset();
                break;
            case CreateApplicationTrainingMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("propertiesForm").get("properties").clear();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationTrainingMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationTrainingMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationTrainingMenuHeadings.Notes.toLocaleLowerCase():
                this.form.get("notesForm").get("note").reset();
                break;
            case CreateApplicationTrainingMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiTrainingConstants.URL}/${jobId}/GetTmApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        return true;
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                type: new FormControl(null, [Validators.required])
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            })
        });
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        const application = {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appControllerService.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicant: [applicant],
            applicantAgent: [],
            notes: [],
            properties: [],
            eLodgementComplete: false,
            eLodgementStep: 0,
            wkid: 102100
        };
        return application;
    }
    buildTrainingDetailsStep(stepIndex, existingApplication) {
        const TrainingDetailsForm = this.form.get("detailsForm").value;
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.type = TrainingDetailsForm.type;
            application.description = TrainingDetailsForm.description;
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appControllerService.selectedModuleID),
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                type: TrainingDetailsForm.type,
                description: TrainingDetailsForm.description
            };
        return application;
    }
    buildLocationStep(stepIndex, existingApplication, missingLookupsForZones) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.properties = [];
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appControllerService.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                properties: [],
                wkid: 102100
            };
        // this should cover the copied applicant
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        if (applicantFormValue) {
            const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
            application.applicant = [applicant];
        }
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            let owners = item.get("owners").value ? item.get("owners").value : [];
            if (owners && owners.length > 0) {
                owners = owners.map((owner) => {
                    owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                    return owner;
                });
            }
            const property = {
                id: item.get("id").value,
                applicationId: item.get("applicationId").value,
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                farmNumber: item.get("farmNo").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                updateGeometry: false,
                wkid: 102100,
                owners,
            };
            application.properties.push(property);
        });
        const shape = `MULTIPOINT (${points.join(", ")})`;
        application.shape = shape;
        return application;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        if (!applicant.id)
            applicant.id = 0;
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appControllerService.selectedModuleID), eLodgementComplete: false,
            };
        }
        existingApplication.eLodgementStep = stepIndex;
        existingApplication.applicant = [applicant];
        return existingApplication;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantAgentFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantAgentFormValue);
        if (existingApplication) {
            existingApplication.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            existingApplication.applicantAgentNa = applicantAgentIsNullValue;
            existingApplication.eLodgementStep = stepIndex;
        }
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return existingApplication;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appControllerService.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: ApplicationCreateService },
        { type: Router }
    ];
};
TmamsStrategyService = TmamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsubPortal()
], TmamsStrategyService);
export { TmamsStrategyService };
